const chat = {
  actions: {
    newChat: 'New chat',
    reconnect: 'Reconnect',
    scrollToBottom: 'Jump to latest message',
    send: 'Send',
    stop: 'Stop',
  },
  attachments: {
    add: 'Upload attachment',
    closePreview: 'Close image preview',
    failed: 'Failed',
    imageAlt: 'Attachment image: {{name}}',
    open: 'Open attachment {{name}}',
    preview: 'Preview attachment {{name}}',
    previewDialogTitle: 'Image preview: {{name}}',
    remove: 'Remove attachment {{name}}',
    uploadFailed: 'Attachment upload failed',
    uploading: 'Uploading',
    errors: {
      localNotAllowed: 'This app does not allow local file uploads.',
      maxCount: 'Upload up to {{count}} attachments.',
      maxSize: 'File size must be under {{size}} MB.',
      removeFailed: 'Remove failed attachments first.',
      unsupportedExtension: 'This file extension is not supported. Allowed: {{extensions}}.',
      unsupportedMime: 'This file MIME type is not supported. Allowed: {{mimeTypes}}.',
      unsupportedType: 'This file type is not supported. Allowed: {{types}}.',
      uploadFailed: 'Attachment upload failed. Try again.',
      waitForUpload: 'Wait for attachments to finish uploading before sending.',
    },
  },
  citations: {
    close: 'Close citation details',
    emptyContent: 'No content available.',
    page: 'Page {{page}}',
    sourceContent: 'Retrieved segment content',
    title: 'Citations',
    untitledDocument: 'Untitled document',
  },
  composer: {
    hint: 'AI can make mistakes. Check important results.',
    label: 'Message input',
    placeholder: 'Message. Enter to send, Shift + Enter for a new line',
    placeholderMobile: 'Message…',
  },
  coreAgent: {
    appsErrorDescription: 'Installed apps could not be loaded. Try again later.',
    appsErrorTitle: 'Unable to select a default app',
    disabledDescription:
      '{{hubAgentName}} is not enabled yet, or no usable model has been configured.',
    disabledTitle: '{{hubAgentName}} unavailable',
    modelList: 'Available models',
    modelListDescription: 'Switch models for {{hubAgentName}} conversations',
    modelSelector: 'Select model',
    modelUnavailable: 'Select an available model before sending.',
    providerAlertTitle: '{{hubAgentName}} call failed',
    providerUnavailable: '{{hubAgentName}} cannot reach the model right now. Try again later.',
    statusErrorDescription:
      'The availability of {{hubAgentName}} could not be confirmed. Try again.',
    statusErrorTitle: 'Unable to load {{hubAgentName}}',
    welcomeSubtitle: 'Ask directly, or pick an app from the menu.',
    welcomeTitle: 'How can I help today?',
  },
  empty: {
    action: 'Go to apps',
    description: 'Choose an installed app to start a conversation.',
    title: 'Choose an app first',
  },
  errors: {
    activeRunReconnectFailed: 'Automatic reconnect failed. The server may still be generating.',
    forbidden: 'You do not have permission to use this app.',
    channelUnavailable: 'This app is not available on the current channel.',
    generic: 'Request failed. Try again later.',
    loadTitle: 'Failed to load chat',
    missingQuery: 'Enter a message before sending.',
    provider: 'This app has a configuration or provider issue. Contact an administrator.',
    providerAlertTitle: 'App call failed',
    retry: 'Retry',
    stopped: 'Generation stopped.',
    submissionRetryExhausted:
      'The connection could not be established. Check your network and send again.',
    unauthorized: 'Your session expired. Sign in again.',
  },
  embed: {
    loadFailedDescription:
      'The target page may block embedding, or the current network cannot reach it.',
    loadFailedTitle: 'Failed to load embedded page',
    missingDescription: 'The backend did not return an actual_url for this app.',
    missingTitle: 'App URL not configured',
    preparingSession: 'Connecting securely…',
    reload: 'Reload',
    sessionFailedDescription: 'The app cannot be opened right now. Try again.',
    sessionFailedTitle: 'Failed to establish single sign-on',
    startingApplication: 'Starting…',
  },
  header: {
    breadcrumbLabel: 'Page hierarchy',
    breadcrumbRoot: 'Apps',
    existingConversation: 'History conversation',
    loadingApp: 'Loading app',
    newConversation: 'New conversation',
  },
  history: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    deleteAction: 'Delete {{title}}',
    deleteDialogDescription: 'The selected conversation will be permanently deleted.',
    deleteDialogTitle: 'Delete conversation',
    emptyDescription: 'Start a conversation and this app will show its history here.',
    emptyTitle: 'No history yet',
    groups: {
      all: 'All',
      earlier: 'Earlier',
      thisMonth: 'This month',
      thisYear: 'This year',
      today: 'Today',
    },
    loadMore: 'Load more',
    noResultsDescription: 'Try a different keyword.',
    noResultsTitle: 'No matching conversations',
    pinAction: 'Pin {{title}}',
    rename: 'Rename',
    renameAction: 'Rename {{title}}',
    renameDialogTitle: 'Rename conversation',
    renameLabel: 'Conversation name',
    renamePlaceholder: 'Enter conversation name',
    searchLabel: 'Search conversation history',
    searchPlaceholder: 'Search conversations',
    searchPlaceholderMobile: 'Filter loaded conversations',
    title: 'Conversation history',
    unpinAction: 'Unpin {{title}}',
  },
  messages: {
    closeViewer: 'Close',
    codeCopied: 'Code copied.',
    contentCopied: 'Copied to clipboard.',
    copyAnswer: 'Copy answer',
    copyCode: 'Copy code',
    copyFailed: 'Copy failed. Copy manually instead.',
    copyUserMessage: 'Copy user message',
    downloadDiagram: 'Download diagram',
    downloadDiagramAsMmd: 'Download as MMD',
    downloadDiagramAsPng: 'Download as PNG',
    downloadDiagramAsSvg: 'Download as SVG',
    downloadFile: 'Download file',
    echartsInvalidOption: 'Unable to render this chart. Check the ECharts JSON option.',
    echartsLoading: 'Rendering chart...',
    echartsPreview: 'Preview',
    echartsSource: 'Source',
    echartsViewMode: 'Switch ECharts view mode',
    emptyHistory: 'This conversation has no displayable messages yet.',
    exitFullscreen: 'Exit fullscreen',
    dislikeAnswer: 'Dislike answer',
    feedbackCleared: 'Feedback cleared.',
    feedbackDisliked: "Got it. We'll keep improving.",
    feedbackFailed: 'Failed to submit feedback. Try again later.',
    feedbackLiked: 'Thanks. Glad this helped.',
    latexLoading: 'Rendering LaTeX...',
    latexPreview: 'Preview',
    latexSource: 'Source',
    latexViewMode: 'Switch LaTeX view mode',
    likeAnswer: 'Like answer',
    mermaidFormatMmd: 'MMD',
    mermaidFormatPng: 'PNG',
    mermaidFormatSvg: 'SVG',
    thinking: 'Thinking...',
    thinkingPlaceholder: 'Working through it...',
    thoughtDone: 'Thought complete',
    thought: 'Thought',
    thoughtDuration: '{{duration}}',
    thoughtDurationSeconds: '{{seconds}}s',
    workflowElapsedMs: '{{ms}}ms',
    workflowElapsedSeconds: '{{seconds}}s',
    workflowNoSteps: 'No step details yet',
    workflowProcess: 'Workflow Process',
    workflowStepFallback: 'Untitled step',
    workflowToggle: 'Expand or collapse workflow steps',
    workflowTokens: '{{count}} tokens',
    viewFullscreen: 'View fullscreen',
    workflowStatus: {
      failed: 'Failed',
      paused: 'Paused',
      running: 'Running',
      stopped: 'Stopped',
      succeeded: 'Succeeded',
      waiting: 'Waiting',
    },
  },
  opening: {
    starters: 'Try starting with',
  },
  suggestions: {
    label: 'Suggested questions',
  },
  toolActivity: {
    completed: 'Tools used: {{count}}',
    detailCopied: 'Copied',
    detailCopy: 'Copy',
    detailInput: 'Input',
    detailLoadFailed: 'Invocation details are unavailable or expired. Try again later.',
    detailLoading: 'Loading invocation details…',
    detailOutput: 'Output',
    failedCount: '{{count}} failed',
    progressLabel: '{{name}} progress',
    running: 'Using tool: {{name}}',
    status: {
      cancelled: 'Cancelled',
      error: 'Failed',
      running: 'Running',
      success: 'Completed',
      unknown: 'Result uncertain',
    },
    title: 'Tool activity',
    unnamed: 'Tool',
  },
  sidebar: {
    conversationActions: 'More actions for {{title}}',
    deleteConversation: 'Delete',
    empty: 'No history yet',
    loading: 'Loading conversations',
    pickApp: 'Choose an app to show chats',
    pinConversation: 'Pin chat',
    pinnedConversation: '{{title}} is pinned',
    renameConversation: 'Rename',
    untitled: 'Untitled conversation',
    unpinConversation: 'Unpin',
    viewAll: 'View all',
  },
  startForm: {
    close: 'Close chat settings',
    description: 'Add the required runtime details before chatting.',
    edit: 'Edit',
    optional: 'Optional',
    required: 'Fill in {{label}}.',
    submit: 'Submit start info',
    submitted: 'Start info submitted',
    title: 'Chat settings',
  },
  voice: {
    cancel: 'Cancel voice input',
    recording: 'Speak now...',
    requestingPermission: 'Requesting microphone access',
    start: 'Voice input',
    stop: 'Stop recording',
    transcribing: 'Transcribing voice',
    errors: {
      deviceUnavailable: 'No microphone is available. Check your device and try again.',
      emptyRecording: 'No speech was recognized. Record again.',
      permissionDenied:
        'Microphone access is blocked. Allow microphone permission in your browser.',
      unsupportedApp: 'This app does not support voice input.',
      unsupportedBrowser: 'This browser does not support recording input.',
    },
  },
  workflow: {
    clear: 'Clear',
    collapseResult: 'Collapse result',
    copyResult: 'Copy result',
    empty: 'Fill in the parameters, then run the workflow.',
    errors: {
      runFailed: 'The workflow failed. Check the process details or try again.',
    },
    result: 'Result',
    run: 'Run',
    status: {
      failed: 'Run failed',
      running: 'Running',
      stopped: 'Stopped',
      succeeded: 'Run complete',
    },
    stop: 'Stop',
    failedBarLabel: 'Run failed · View details',
    stoppedBarLabel: 'Stopped · View process',
    viewResult: 'View result',
  },
}

export default chat
